import { ChangeEvent, KeyboardEvent } from "react";
import classNames from "classnames";
import "./dls-textinput.scss";
import { IDSSTextInputProps } from "../../building-blocks/DSSFramework";

export const DLSTextInput = ({ value, label, onChange, placeholder = '', disabled, type = 'text', id, name, className, style, startIcon, endIcon, required = false, maxLength, ...props }: IDSSTextInputProps) =>
{
    const textInputClass = classNames('text-input-field', {
        'input-with-startIcon': startIcon,
        'input-with-endIcon': endIcon,

    });

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) =>
    {
        if (maxLength && event.target.value.length > maxLength)
        {
            event.target.value = event.target.value.slice(0, maxLength);
        }
        if (onChange)
        {
            onChange(event);
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) =>
    {
        if (type === 'number')
        {
            // Prevent default behavior for invalid keys
            if (event.key === 'e' || event.key === '+' || event.key === '-' || event.key === ' ' || event.key === 'Enter')
            {
                event.preventDefault();
            }
        }
    };

    return (
        <div
            className="text-input-container"
            style={ style }
        >
            { label && (
                <label htmlFor={ id } className={ `text-input-label ${ disabled ? 'disabled' : '' }` } >
                    { label }
                    { !disabled && (required ? <span className="required-asterisk">   Required</span> : <span className="required-asterisk"></span>) }
                </label>
            ) }

            <div className="custom-textInput-container">
                { startIcon && <span className="text-input-start-icon">{ startIcon }</span> }

                <input
                    { ...props }
                    type={ type }
                    value={ value }
                    onChange={ handleInputChange }
                    className={ classNames(textInputClass, className + (disabled ? ' disabled' : '')) }
                    disabled={ disabled || (props.readOnly ?? false) }
                    placeholder={ placeholder }
                    id={ id }
                    name={ name }
                    onKeyDown={ handleKeyDown }
                    data-testid={ props.dataTestId ?? id }
                    maxLength={ maxLength }
                />
                { endIcon && <span className="text-input-end-icon">{ endIcon }</span> }
            </div>
        </div >
    );
};